module.exports = __webpack_public_path__ + "static/media/gpsbrainstormkit.0af749c1.pdf";